<template>
    <ui-modal
        :icon-circle="true"
        name="active-offer"
        title="Oferta Ativa"
        size="md"
        icon="fal fa-tags"
        color-circle='icon-primary'>
        <ui-overlay-load v-if="loader.load" bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />

        <div class="modal-content">
            <div v-if="layout.noActiveOffers">
                <span class="no-active-offers">Você não possui ofertas ativas!</span>
            </div>

            <div v-if="layout.selectActiveOffer" class="select-active-offer-queue">
                <form class="form">
                    <ui-select
                        v-model="form.data.queue_id"
                        name="active-offers-queue"
                        label="Escolha a fila:"
                        size="md">
                        <option
                            v-for="(option, index) in queueOptions"
                            :key="index"
                            :value="option.value">
                            {{ option.label }}
                        </option>
                    </ui-select>
                </form>
            </div>

            <div v-if="layout.activeOfferList" class="active-offer-queue-list">
                <ui-table
                    :columns="tableColumns"
                    :data="tableData"
                    :loading="false"
                    :select-column-menu="false"
                    not-found-icon="fa fa-file-contract"
                    not-found-text="Não foi possível encontrar nenhuma fila"
                    name="active-offer-list"
                    tr-component="active-offer/table-line" />
            </div>
        </div>

        <template #footer>
            <ui-button
                type="button"
                design="md link"
                data-dismiss="modal"
                @click="resetActiveOffer">
                Cancelar
            </ui-button>

            <ui-button
                v-if="layout.selectActiveOffer"
                type="button"
                design="md primary"
                @click="getOffer">
                Selecionar
            </ui-button>

            <ui-button
                v-if="layout.activeOfferList"
                type="button"
                design="md primary"
                @click="saveOffer">
                Salvar
            </ui-button>
        </template>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components/ui/modal'
    import { uiOverlayLoad, uiTable } from '@/components/ui'
    import { uiSelect } from '@/components/ui/form'
    import { uiButton } from '@/components/ui/buttons'

    import { activeOffer } from '@/services/axios'

    const defaultLoader = () => {
        return {
            load: false
        }
    }

    const defaultLayout = () => {
        return {
            noActiveOffers: false,
            selectActiveOffer: false,
            activeOfferList: false
        }
    }

    const defaultFormData = () => {
        return {
            queue_id: null,
            offer_id: null,
            offer: null,
            reason_id: null
        }
    }

    export default {
        name:'active-offer-modal',
        components: {
            uiModal,
            uiOverlayLoad,
            uiSelect,
            uiButton,
            uiTable
        },

        data() {
            return {
                loader: { ...defaultLoader() },
                layout: { ...defaultLayout() },
                form: {
                    data: { ...defaultFormData() }
                },
                queueOptions: [],
                reasonOptions: [],
                tableColumns: [
                    {
                        title: 'Name',
                        size: '200'
                    },
                    {
                        title: 'E-mail'
                    },
                    {
                        title: 'Telefone',
                        size: '100'
                    },
                    {
                        title: 'Classificação',
                        size: '180'
                    }
                ]
            }
        },

        computed: {
            tableData() {
                let data = []
                if (this.form.data.offer_id && this.form.data.offer) {
                    data = [{
                        id: this.form.data.offer_id,
                        name: this.form.data.offer.name,
                        email: this.form.data.offer.email,
                        phone: this.form.data.offer.phone,
                        reasons: [...this.reasonOptions]
                    }]
                }

                return data
            }
        },

        mounted () {
            this.$root.$on('modal-open-active-offer', () => {
                this.loadForm()
            })

            this.$root.$on('active-offer-reason-selected', (payload) => {
                this.$set(this.form.data, 'reason_id', payload)
            })
        },

        beforeDestroy () {
            this.$root.$off('modal-open-active-offer')
            this.$root.$off('active-offer-reason-selected')
        },

        methods: {
            loadForm() {
                if (!(this.$store.state.auth.user && this.$store.state.auth.user.id)) return

                this.$set(this.loader, 'load', true)
                activeOffer.getUserQueues(this.$store.state.auth.user.id)
                    .then(response => {
                        this.queueOptions = [...response.data]
                        if (this.queueOptions.length) {
                            this.$set(this.layout, 'selectActiveOffer', true)

                        } else {
                            this.$set(this.layout, 'noActiveOffers', true)
                        }
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.$set(this.loader, 'load', false)
                    })
            },
            /**
             * Trata o evento de quando uma fila de Leads ativa é selecionada
             */
            getOffer: async function () {
                try {
                    this.$set(this.loader, 'load', true)

                    let response = await activeOffer.getQueueReasons(this.form.data.queue_id)
                    this.reasonOptions = [...response.data]

                    response = await activeOffer.getOffer(this.form.data.queue_id)
                    if (response.data) {
                        this.$set(this.form.data, 'offer', { ...response.data })
                        this.$set(this.form.data, 'offer_id', this.form.data.offer.id)
                    }
                    this.$set(this.layout, 'selectActiveOffer', false)
                    this.$set(this.layout, 'activeOfferList', true)

                } catch (error) {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    console.log(error)

                } finally {
                    this.$set(this.loader, 'load', false)
                }
            },
            resetForm() {
                this.$set(this.form, 'data', { ...defaultFormData() })
                this.layout = { ...defaultLayout() }
            },
            /**
             * Reseta o formulário e fecha o modal
             */
            resetActiveOffer() {
                this.resetForm()
                this.$root.$emit('modal-close-active-offer')
            },
            /**
             * Salva os dados de processamento na fila de Leads selecionada
             */
            saveOffer() {
                if (this.form.data.queue_id && this.form.data.offer_id && this.form.data.reason_id) {
                    this.$set(this.loader, 'load', true)
                    const data = {
                        offer_id: this.form.data.offer_id,
                        reason_id: this.form.data.reason_id
                    }
                    activeOffer.saveOffer(this.form.data.queue_id, data)
                        .then(response => {
                            this.$toastr.s(response.data.msg)
                            this.resetForm()
                            this.reasonOptions = []
                            if (this.queueOptions.length) {
                                this.$set(this.layout, 'selectActiveOffer', true)

                            } else {
                                this.$set(this.layout, 'noActiveOffers', true)
                            }
                        })
                        .catch(error => {
                            if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                            console.log(error)
                        })
                        .finally(() => {
                            this.$set(this.loader, 'load', false)
                        })
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>